<template>
  <v-container fluid :class="['management-list-page', 'other-proceedings-shadcn', 'pa-6', pageClass]">
    <div class="op-page-header">
      <div>
        <v-breadcrumbs class="app-breadcrumb pa-0 mb-2" divider="›" :items="breadcrumbs" />
        <h1 class="op-heading">{{ title }}</h1>
        <p v-if="subtitle" class="op-subtitle">{{ subtitle }}</p>
        <small v-if="resultText" class="op-result-meta">{{ resultText }}</small>
      </div>
      <div class="op-header-actions"><slot name="actions" /></div>
    </div>

    <div v-if="summaryCards.length" class="op-summary-strip mb-3">
      <button v-for="card in summaryCards" :key="card.key" type="button" class="op-summary-card"
        :class="{ active: card.active }" @click="$emit('summary-click', card)">
        <span class="op-summary-dot" :class="`tone-${card.tone || card.color || 'neutral'}`" />
        <span class="op-summary-label">{{ card.label }}</span>
        <strong v-if="card.value !== undefined && card.value !== null && card.value !== ''">{{ card.value }}</strong>
      </button>
    </div>

    <div v-if="$slots.navigation" class="management-list-navigation"><slot name="navigation" /></div>

    <v-card flat class="op-card op-list-card management-list-card">
      <v-card-text v-if="$slots.filters" class="op-filter-area"><slot name="filters" /></v-card-text>
      <v-divider v-if="$slots.filters" />
      <div v-if="$slots.tableActions" class="management-list-table-actions"><slot name="tableActions" /></div>
      <slot name="table" />
    </v-card>

    <slot />
  </v-container>
</template>

<script>
export default {
  name: "ManagementListPage",
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: "" },
    resultText: { type: String, default: "" },
    breadcrumbs: { type: Array, default: () => [] },
    summaryCards: { type: Array, default: () => [] },
    pageClass: { type: [String, Array, Object], default: "" },
  },
};
</script>

<style lang="scss" scoped>
.management-list-page { min-height: 100%; }
.management-list-navigation { margin-bottom: 12px; }
.management-list-table-actions { display: flex; align-items: center; justify-content: space-between; min-height: 46px; padding: 8px 12px; border-bottom: 1px solid #edf1f5; }
.management-list-table-title { color: #0f172a; font-size: 13px; font-weight: 700; }

.management-list-page ::v-deep .op-header-actions .v-btn {
  min-width: 0;
  height: 36px;
  padding: 0 14px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.2;
  letter-spacing: 0;
  text-transform: none;
}
.management-list-page ::v-deep .op-filter-area .row { margin: -5px; }
.management-list-page ::v-deep .op-filter-area .col { padding: 5px; }
.management-list-page ::v-deep .op-filter-area .v-input__slot {
  min-height: 44px !important;
  border-radius: 6px !important;
}
.management-list-page ::v-deep .management-advanced-filters .v-input,
.management-list-page ::v-deep .management-advanced-filters .v-input__control {
  width: 100%;
  margin: 0 !important;
  padding: 0 !important;
}
.management-list-page ::v-deep .management-advanced-filters .v-input__slot {
  display: flex !important;
  align-items: center !important;
  height: 44px !important;
  min-height: 44px !important;
  margin: 0 !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.management-list-page ::v-deep .management-advanced-filters .v-text-field__slot,
.management-list-page ::v-deep .management-advanced-filters .v-select__slot {
  align-items: center !important;
  height: 42px !important;
  min-height: 42px !important;
}
.management-list-page ::v-deep .management-advanced-filters input,
.management-list-page ::v-deep .management-advanced-filters .v-select__selection {
  align-self: center !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  line-height: 20px !important;
}
.management-list-page ::v-deep .management-advanced-filters .v-input__append-inner,
.management-list-page ::v-deep .management-advanced-filters .v-input__prepend-inner {
  align-self: center !important;
  margin-top: 0 !important;
}
.management-list-page ::v-deep .management-advanced-filters .v-label:not(.v-label--active) {
  top: 13px !important;
}
.management-list-page ::v-deep .op-quick-filters {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #edf1f5;
}
.management-list-page ::v-deep .op-quick-filters-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}
.management-list-page ::v-deep .op-quick-filters-head strong,
.management-list-page ::v-deep .op-quick-filters-head span { display: block; }
.management-list-page ::v-deep .op-quick-filters-head strong { color: #334155; font-size: 11px; }
.management-list-page ::v-deep .op-quick-filters-head > div > span { margin-top: 2px; color: #64748b; font-size: 9px; }
.management-list-page ::v-deep .op-current-filter {
  display: inline-flex !important;
  align-items: center;
  gap: 5px;
  min-height: 26px;
  padding: 0 9px;
  color: #334155;
  font-size: 9px;
  font-weight: 600;
  border: 1px solid #dfe5ec;
  border-radius: 999px;
  background: #f8fafc;
}
.management-list-page ::v-deep .op-quick-filter-categories,
.management-list-page ::v-deep .op-quick-filter-options {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}
.management-list-page ::v-deep .op-quick-filter-categories { margin-bottom: 8px; }
.management-list-page ::v-deep .op-quick-filter-categories button,
.management-list-page ::v-deep .op-quick-filter-options button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  min-height: 30px;
  padding: 0 10px;
  color: #475569;
  font-family: "Plus Jakarta Sans", "Roboto", sans-serif;
  font-size: 9px;
  font-weight: 600;
  line-height: 1;
  border: 1px solid #dfe5ec;
  border-radius: 6px;
  background: #fff;
}
.management-list-page ::v-deep .op-quick-filter-categories button:hover,
.management-list-page ::v-deep .op-quick-filter-options button:hover { border-color: #94a3b8; background: #f8fafc; }
.management-list-page ::v-deep .op-quick-filter-categories button.active,
.management-list-page ::v-deep .op-quick-filter-options button.active {
  color: var(--v-primary-base);
  border-color: rgba(1, 67, 115, .28);
  background: rgba(1, 67, 115, .06);
}
.management-list-page ::v-deep .op-quick-filter-options .v-icon { margin: 0 !important; font-size: 13px !important; }
.management-list-page ::v-deep .op-filter-area input,
.management-list-page ::v-deep .op-filter-area input::placeholder,
.management-list-page ::v-deep .op-filter-area .v-label,
.management-list-page ::v-deep .op-filter-area .v-select__selection,
.management-list-page ::v-deep .op-filter-area .v-select__selection--comma {
  font-family: "Plus Jakarta Sans", "Roboto", sans-serif !important;
  font-size: 11px !important;
  font-weight: 400 !important;
  letter-spacing: 0 !important;
  line-height: 1.45 !important;
}
.management-list-page ::v-deep .op-filter-area input::placeholder { color: #94a3b8 !important; opacity: 1 !important; }
.management-list-page ::v-deep .op-filter-area #btnFilter,
.management-list-page ::v-deep .op-filter-area #btnClearFilter,
.management-list-page ::v-deep .op-filter-area .v-btn--outlined {
  min-width: 0;
  height: 36px;
  padding: 0 16px;
  border-radius: 6px;
  box-shadow: none !important;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0;
  text-transform: none;
}
.management-list-page ::v-deep .op-filter-area .v-btn--outlined {
  color: #334155 !important;
  background: #fff !important;
  border-color: #cbd5e1 !important;
}
.management-list-page ::v-deep .op-filter-area .v-btn--outlined:hover { background: #f8fafc !important; border-color: #94a3b8 !important; }
.management-list-page ::v-deep .management-list-navigation .v-tabs-bar { height: 48px; border: 1px solid #dfe5ec; border-radius: 8px; }
.management-list-page ::v-deep .management-list-navigation .v-tab { min-width: 0; padding: 0 16px; font-size: 11px; font-weight: 600; letter-spacing: 0; text-transform: none; }
.management-list-page ::v-deep .management-list-table > .v-data-table__wrapper { border-radius: 0; }
.management-list-page ::v-deep .management-minimal-table tbody td {
  height: 50px;
  color: #334155;
  font-size: 10px;
  font-weight: 400;
}
.management-list-page ::v-deep .op-cell-id { display: inline-flex; align-items: center; gap: 4px; }
.management-list-page ::v-deep .op-cell-id strong,
.management-list-page ::v-deep .op-cell-primary { color: #172033; font-size: 10px; font-weight: 600; }
.management-list-page ::v-deep .op-cell-secondary { color: #475569; font-size: 9px; }
.management-list-page ::v-deep .op-cell-muted { color: #94a3b8; }
.management-list-page ::v-deep .op-table-badge {
  display: inline-flex;
  align-items: center;
  min-height: 22px;
  padding: 0 7px;
  font-size: 8px;
  font-weight: 700;
  line-height: 1;
  letter-spacing: .01em;
  text-transform: uppercase;
  border: 1px solid currentColor;
  border-radius: 5px;
}
.management-list-page ::v-deep .op-table-badge.tone-neutral { color: #475569 !important; background: #f8fafc !important; border-color: #dfe5ec; }
.management-list-page ::v-deep .op-table-badge.tone-success { border-color: #a6f4c5; }
.management-list-page ::v-deep .op-table-badge.tone-warning { border-color: #fedf89; }
.management-list-page ::v-deep .op-table-badge.tone-danger { border-color: #fecdca; }
.management-list-page ::v-deep .op-table-badge.tone-purple { border-color: #d9d6fe; }
.management-list-page ::v-deep .op-row-actions { display: flex; align-items: center; justify-content: flex-end; gap: 2px; white-space: nowrap; }
.management-list-page ::v-deep .op-row-actions .v-btn { width: 26px; height: 26px; color: #64748b; }
.management-list-page ::v-deep .op-row-actions .v-btn:hover { color: var(--v-primary-base); background: #f1f5f9; }
.management-list-page ::v-deep .op-row-actions .v-icon { margin: 0 !important; font-size: 15px !important; }

@media (max-width: 720px) {
  .management-list-page ::v-deep .op-header-actions { justify-content: flex-start; }
  .management-list-table-actions { align-items: flex-start; flex-direction: column; gap: 8px; }
}
</style>
